import { Reveal, Stagger, StaggerItem } from "@/components/Motion";
import BookingDialog from "@/components/BookingDialog";
import Seo from "@/components/Seo";
import { EVENTS } from "@/data/content";

export default function Eventi() {
  return (
    <div className="pt-32 pb-28 min-h-screen constellation">
      <Seo title="Eventi" description="Eventi, cerchi di meditazione, serate akashiche e ritiri LUX AETERNA: date, luoghi e prenotazione online." />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.25em] text-gold mb-5">Eventi</p>
          <h1 className="font-display text-5xl sm:text-7xl text-[#2A1F14] leading-[1.02] max-w-3xl mb-8">Conferenze, workshop ed esperienze immersive.</h1>
          <p className="text-[#2A1F14]/55 text-lg max-w-2xl leading-relaxed">Momenti dal vivo per approfondire, praticare e trasformarti. Prenotazione online per ogni evento.</p>
        </Reveal>

        <Stagger className="mt-16 space-y-4">
          {EVENTS.map((e) => (
            <StaggerItem key={e.slug}>
              <div className="border border-[#2A1F14]/10 rounded-2xl p-8 hover:border-gold/40 hover:bg-[#EFE3CE] transition-colors duration-500 grid lg:grid-cols-12 gap-6 items-center" data-testid={`event-${e.slug}`}>
                <div className="lg:col-span-2">
                  <span className="text-[10px] uppercase tracking-[0.2em] text-gold">{e.type}</span>
                </div>
                <div className="lg:col-span-5">
                  <h3 className="font-display text-2xl text-[#2A1F14] leading-snug">{e.title}</h3>
                  <p className="text-[#2A1F14]/45 text-sm mt-2">{e.description}</p>
                </div>
                <div className="lg:col-span-3 text-sm">
                  <p className="text-[#2A1F14]/70">{e.date}</p>
                  <p className="text-[#2A1F14]/40">{e.location}</p>
                  <p className="text-gold mt-1">{e.price}</p>
                </div>
                <div className="lg:col-span-2 lg:text-right">
                  <BookingDialog title={`Prenota — ${e.title}`} presets={{ type: "evento", service: e.title }}
                    trigger={<button data-testid={`event-book-${e.slug}`} className="px-6 py-3 rounded-full bg-gold text-black text-sm font-medium hover:bg-[#D4A056] transition-colors whitespace-nowrap">Prenota</button>} />
                </div>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </div>
  );
}
